import {
  useSetWorkspaceFilter,
  useValidateWorkspaceListOrder,
  useWorkspaceFilter,
} from '@gripp/shared-logic';
import { SlideAction, useSlideLayout, ViewMode } from '@gripp/shared-ui';
import { useRef } from 'react';
import { useNavigate } from 'react-router';
import { HeaderResetButton } from '../../shared/components/headerResetButton/headerResetButton';
import { Workspaces } from './workspaces';
import {
  WorkspacesFilterScreen,
  WorkspacesFilterScreenHandle,
} from './workspacesFilterScreen';

export const WorkspacesFilterPage = () => {
  const filterRef = useRef<WorkspacesFilterScreenHandle>(null);
  const onBackButtonPressRef = useRef<(() => void) | undefined>(undefined);

  const { data: filter } = useWorkspaceFilter();
  const { mutateAsync: setFilter } = useSetWorkspaceFilter();
  const validateListOrder = useValidateWorkspaceListOrder();

  const rightColumn = {
    title: 'admin.menu.workspaces',
    mainComponent: (
      <>
        <WorkspacesFilterScreen
          ref={filterRef}
          filter={filter}
          setFilter={setFilter}
          validateListOrder={validateListOrder}
        />
        <BackHandlerRegistrar onBackButtonPressRef={onBackButtonPressRef} />
      </>
    ),
    headerComponent: (
      <HeaderResetButton onReset={() => filterRef.current?.onReset()} />
    ),
    showBackButton: true,
    onBackButtonPress: () => onBackButtonPressRef.current?.(),
  };

  return <Workspaces rightColumn={rightColumn} viewMode={ViewMode.DUAL} />;
};

const BackHandlerRegistrar = ({
  onBackButtonPressRef,
}: {
  onBackButtonPressRef: React.MutableRefObject<(() => void) | undefined>;
}) => {
  const navigate = useNavigate();
  const { onSlideChange } = useSlideLayout();

  onBackButtonPressRef.current = async () => {
    await onSlideChange(SlideAction.SINGLE);
    navigate('/workspaces');
  };

  return null;
};
